import defImg from "@/assets/images/local.png";

// key计算起始,写完标记一下
/**
 * 各项最大值
 * 00000094
 * 10000354
 * 20000354
 * 30000354
 * 40000354
 * 50000354
 * 60000354
 */

export const entry = {
  base: {
    character: {
      avatar: { key: "00000001", type: "image", value: defImg },
      /** 无边框头像 */
      avatarFrame: { key: "00000082", type: "image", value: defImg },
      name: { key: "00000002", type: "text", value: "名称" },
      py: { key: "00000084", type: "text", value: "pinyin" },
      stars: { key: "00000003", type: "text", value: 1 },
      attr1: {
        icon: { key: "00000004", type: "image", value: defImg },
        name: { key: "00000005", type: "text", value: "属性1" }
      },
      attr2: {
        icon: { key: "00000200", type: "image", value: defImg },
        name: { key: "00000006", type: "text", value: "属性2" }
      },
      attr3: {
        icon: { key: "00000007", type: "image", value: defImg },
        name: { key: "00000008", type: "text", value: "属性3" }
      },
      attr4: {
        icon: { key: "00000009", type: "image", value: defImg },
        name: { key: "00000010", type: "text", value: "属性4" }
      },
      audioType: { key: "00000083", type: "text", value: "音色" }
    },
    attr: {
      attr1: {
        icon: { key: "00000011", type: "image", value: require("@/assets/zs_imgs/attr/icon1.png") },
        name: { key: "00000012", type: "text", value: "属性1" },
        level1: { key: "00000013", type: "text", value: 1 },
        level100: { key: "00000014", type: "text", value: 100 },
        levelFull: { key: "00000015", type: "text", value: 100 }
      },
      attr2: {
        icon: { key: "00000016", type: "image", value: require("@/assets/zs_imgs/attr/icon2.png") },
        name: { key: "00000017", type: "text", value: "属性2" },
        level1: { key: "00000018", type: "text", value: 2 },
        level100: { key: "00000019", type: "text", value: 100 },
        levelFull: { key: "00000020", type: "text", value: 100 }
      },
      attr3: {
        icon: { key: "00000021", type: "image", value: require("@/assets/zs_imgs/attr/icon3.png") },
        name: { key: "00000022", type: "text", value: "属性3" },
        level1: { key: "00000023", type: "text", value: 3 },
        level100: { key: "00000024", type: "text", value: 100 },
        levelFull: { key: "00000025", type: "text", value: 100 }
      },
      attr4: {
        icon: { key: "00000026", type: "image", value: require("@/assets/zs_imgs/attr/icon4.png") },
        name: { key: "00000027", type: "text", value: "属性4" },
        level1: { key: "00000028", type: "text", value: 4 },
        level100: { key: "00000029", type: "text", value: 100 },
        levelFull: { key: "00000030", type: "text", value: 100 }
      },
      attr5: {
        icon: { key: "00000031", type: "image", value: require("@/assets/zs_imgs/attr/icon5.png") },
        name: { key: "00000032", type: "text", value: "属性5" },
        level1: { key: "00000033", type: "text", value: 5 },
        level100: { key: "00000034", type: "text", value: 100 },
        levelFull: { key: "00000035", type: "text", value: 100 }
      },
      attr6: {
        icon: { key: "00000036", type: "image", value: require("@/assets/zs_imgs/attr/icon6.png") },
        name: { key: "00000037", type: "text", value: "属性6" },
        level1: { key: "00000038", type: "text", value: 6 },
        level100: { key: "00000039", type: "text", value: 100 },
        levelFull: { key: "00000040", type: "text", value: 100 }
      },
      attr7: {
        icon: { key: "00000041", type: "image", value: require("@/assets/zs_imgs/attr/icon7.png") },
        name: { key: "00000042", type: "text", value: "属性7" },
        level1: { key: "00000043", type: "text", value: 7 },
        level100: { key: "00000044", type: "text", value: 100 },
        levelFull: { key: "00000045", type: "text", value: 100 }
      },
      attr8: {
        icon: { key: "00000046", type: "image", value: require("@/assets/zs_imgs/attr/icon8.png") },
        name: { key: "00000047", type: "text", value: "属性8" },
        level1: { key: "00000048", type: "text", value: 8 },
        level100: { key: "00000049", type: "text", value: 100 },
        levelFull: { key: "00000050", type: "text", value: 100 }
      },
      attr9: {
        icon: { key: "00000051", type: "image", value: require("@/assets/zs_imgs/attr/icon9.png") },
        name: { key: "00000052", type: "text", value: "属性9" },
        level1: { key: "00000053", type: "text", value: 9 },
        level100: { key: "00000054", type: "text", value: 100 },
        levelFull: { key: "00000055", type: "text", value: 100 }
      }
    },
    exclusiveEquipment: {
      icon: { key: "00000056", type: "image", value: defImg },
      name: { key: "00000057", type: "text", value: "专属装备" },
      equipType: { key: "00000183", type: "text", value: "饰品" },
      attr0: {
        label: { key: "00000058", type: "text", value: "专用能力：" },
        desc: { key: "00000059", type: "text", value: "描述" }
      },
      attr1: {
        label: { key: "00000060", type: "text", value: "基础能力1：" },
        desc: { key: "00000061", type: "text", value: "描述" }
      },
      attr2: {
        label: { key: "00000062", type: "text", value: "基础能力2：" },
        desc: { key: "00000063", type: "text", value: "描述" }
      }
    },
    talentSkill: {
      icon: { key: "00000064", type: "image", value: require("@/assets/zs_imgs/talent/icon1.png") },
      name: { key: "00000065", type: "text", value: "天赋技能" },
      desc: { key: "00000066", type: "text", value: "描述" },
      upgrade: {
        level1: {
          icon: { key: "00000067", type: "image", value: require("@/assets/zs_imgs/talent/icon1.png") },
          name: { key: "00000068", type: "text", value: "升级1" },
          desc: { key: "00000069", type: "text", value: "描述" }
        },
        level2: {
          icon: { key: "00000070", type: "image", value: require("@/assets/zs_imgs/talent/icon2.png") },
          name: { key: "00000071", type: "text", value: "升级2" },
          desc: { key: "00000072", type: "text", value: "描述" }
        },
        level3: {
          icon: { key: "00000073", type: "image", value: require("@/assets/zs_imgs/talent/icon3.png") },
          name: { key: "00000074", type: "text", value: "升级3" },
          desc: { key: "00000075", type: "text", value: "描述" }
        },
        level4: {
          icon: { key: "00000076", type: "image", value: require("@/assets/zs_imgs/talent/icon4.png") },
          name: { key: "00000077", type: "text", value: "升级4" },
          desc: { key: "00000078", type: "text", value: "描述" }
        },
        level5: {
          icon: { key: "00000079", type: "image", value: require("@/assets/zs_imgs/talent/icon5.png") },
          name: { key: "00000080", type: "text", value: "升级5" },
          desc: { key: "00000081", type: "text", value: "描述" }
        }
      }
    },
    engraving: {
      value1: { key: "00000085", type: "text", value: "属性值1" },
      value2: { key: "00000086", type: "text", value: "属性值2" },
      value3: { key: "00000087", type: "text", value: "属性值3" },
      label1: { key: "00000090", type: "text", value: "属性名1" },
      label2: { key: "00000091", type: "text", value: "属性名2" },
      label3: { key: "00000092", type: "text", value: "属性名3" }
    },
    awakening: {
      value1: { key: "00000088", type: "text", value: "属性值1" },
      value2: { key: "00000089", type: "text", value: "属性值2" },
      label1: { key: "00000093", type: "text", value: "属性名1" },
      label2: { key: "00000094", type: "text", value: "属性名2" }
    }
  },

  style: {
    style1: {
      name: { key: "10000202", type: "text", value: "名称" },
      tag: { key: "10000201", type: "text", value: "标签" },
      icon: { key: "10000081", type: "image", value: defImg },
      icon1: { key: "10000220", type: "image", value: defImg },
      icon2: { key: "10000221", type: "image", value: defImg },
      icon3: { key: "10000222", type: "image", value: defImg },
      icon4: { key: "10000223", type: "image", value: defImg },
      live2d: {
        source: {
          key: "10000082",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jh_source: {
          key: "10000352",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jn_source: {
          key: "10000353",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        cg_source: {
          key: "10000354",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        lh: { key: "10000185", type: "image", value: defImg }
      },
      skill: {
        icon: { key: "10000083", type: "image", value: defImg },
        name: { key: "10000084", type: "text", value: "技能" },
        video: { key: "10000184", type: "video", value: "" },
        desc: { key: "10000085", type: "text", value: "描述" },
        sp: { key: "10000086", type: "text", value: 0 },
        cd: { key: "10000087", type: "text", value: 0 },
        ability1: {
          name: { key: "10000181", type: "text", value: "绑定能力" },
          desc: { key: "10000088", type: "text", value: "描述" }
        },
        ability2: {
          name: { key: "10000182", type: "text", value: "共同能力" },
          desc: { key: "10000089", type: "text", value: "描述" }
        },
        attr1: {
          icon: { key: "10000090", type: "image", value: defImg },
          name: { key: "10000091", type: "text", value: "属性1" }
        },
        attr2: {
          icon: { key: "10000092", type: "image", value: defImg },
          name: { key: "10000093", type: "text", value: "属性2" }
        },
        attr3: {
          icon: { key: "10000094", type: "image", value: defImg },
          name: { key: "10000095", type: "text", value: "属性3" }
        },
        upgrade: {
          level1: {
            icon: { key: "10000096", type: "image", value: defImg },
            name: { key: "10000097", type: "text", value: "升级1" },
            sp: { key: "10000186", type: "text", value: 0 },
            cd: { key: "10000187", type: "text", value: 0 },
            desc: { key: "10000098", type: "text", value: "描述" }
          },
          level2: {
            icon: { key: "10000099", type: "image", value: defImg },
            name: { key: "10000100", type: "text", value: "升级2" },
            sp: { key: "10000188", type: "text", value: 0 },
            cd: { key: "10000189", type: "text", value: 0 },
            desc: { key: "10000101", type: "text", value: "描述" }
          },
          level3: {
            icon: { key: "10000102", type: "image", value: defImg },
            name: { key: "10000103", type: "text", value: "升级3" },
            sp: { key: "10000190", type: "text", value: 0 },
            cd: { key: "10000191", type: "text", value: 0 },
            desc: { key: "10000104", type: "text", value: "描述" }
          },
          level4: {
            icon: { key: "10000155", type: "image", value: defImg },
            name: { key: "10000156", type: "text", value: "升级4" },
            sp: { key: "10000192", type: "text", value: 0 },
            cd: { key: "10000193", type: "text", value: 0 },
            desc: { key: "10000157", type: "text", value: "描述" }
          },
          level5: {
            icon: { key: "10000158", type: "image", value: defImg },
            name: { key: "10000159", type: "text", value: "升级5" },
            sp: { key: "10000194", type: "text", value: 0 },
            cd: { key: "10000195", type: "text", value: 0 },
            desc: { key: "10000160", type: "text", value: "描述" }
          },
          level6: {
            icon: { key: "10000161", type: "image", value: defImg },
            name: { key: "10000162", type: "text", value: "升级6" },
            sp: { key: "10000196", type: "text", value: 0 },
            cd: { key: "10000197", type: "text", value: 0 },
            desc: { key: "10000163", type: "text", value: "描述" }
          },
          level7: {
            icon: { key: "10000164", type: "image", value: defImg },
            name: { key: "10000165", type: "text", value: "升级7" },
            sp: { key: "10000198", type: "text", value: 0 },
            cd: { key: "10000199", type: "text", value: 0 },
            desc: { key: "10000166", type: "text", value: "描述" }
          }
        },
        // 潜力
        potential: {
          item1: {
            icon: { key: "10000343", type: "image", value: defImg },
            desc: { key: "10000344", type: "text", value: "描述" },
            iconDesc: { key: "10000349", type: "image", value: defImg }
          },
          item2: {
            icon: { key: "10000345", type: "image", value: defImg },
            desc: { key: "10000346", type: "text", value: "描述" },
            iconDesc: { key: "10000350", type: "image", value: defImg }
          },
          item3: {
            icon: { key: "10000347", type: "image", value: defImg },
            desc: { key: "10000348", type: "text", value: "描述" },
            iconDesc: { key: "10000351", type: "image", value: defImg }
          }
        }
      },
      introduction: {
        slogn: { key: "10000105", type: "text", value: "简介" },
        nl: {
          label: { key: "10000106", type: "text", value: "年龄" },
          desc: { key: "10000107", type: "text", value: "描述" }
        },
        sg: {
          label: { key: "10000108", type: "text", value: "身高" },
          desc: { key: "10000109", type: "text", value: "描述" }
        },
        sr: {
          label: { key: "10000167", type: "text", value: "生日" },
          desc: { key: "10000168", type: "text", value: "描述" }
        },
        xq: {
          label: { key: "10000110", type: "text", value: "兴趣" },
          desc: { key: "10000111", type: "text", value: "描述" }
        },
        tyddx: {
          label: { key: "10000112", type: "text", value: "讨厌的东西" },
          desc: { key: "10000113", type: "text", value: "描述" }
        },
        sszw: {
          label: { key: "10000114", type: "text", value: "所属/职位" },
          desc: { key: "10000115", type: "text", value: "描述" }
        },
        xhddx: {
          label: { key: "10000116", type: "text", value: "喜欢的东西" },
          desc: { key: "10000117", type: "text", value: "描述" }
        },
        zxddx: {
          label: { key: "10000118", type: "text", value: "珍惜的东西" },
          desc: { key: "10000119", type: "text", value: "描述" }
        },
        cw1: {
          label: { key: "10000120", type: "text", value: "传闻1" },
          desc: { key: "10000121", type: "text", value: "描述" }
        },
        cw2: {
          label: { key: "10000122", type: "text", value: "传闻2" },
          desc: { key: "10000123", type: "text", value: "描述" }
        }
      },
      voices: {
        voices1: {
          source: { key: "10000124", type: "audio", value: "" },
          label: { key: "10000125", type: "text", value: "描述" },
          desc: { key: "10000126", type: "text", value: "描述" }
        },
        voices2: {
          source: { key: "10000127", type: "audio", value: "" },
          label: { key: "10000128", type: "text", value: "描述" },
          desc: { key: "10000129", type: "text", value: "描述" }
        },
        voices3: {
          source: { key: "10000130", type: "audio", value: "" },
          label: { key: "10000131", type: "text", value: "描述" },
          desc: { key: "10000132", type: "text", value: "描述" }
        },
        voices4: {
          source: { key: "10000140", type: "audio", value: "" },
          label: { key: "10000141", type: "text", value: "描述" },
          desc: { key: "10000142", type: "text", value: "描述" }
        },
        voices5: {
          source: { key: "10000143", type: "audio", value: "" },
          label: { key: "10000144", type: "text", value: "描述" },
          desc: { key: "10000145", type: "text", value: "描述" }
        },
        voices6: {
          source: { key: "10000146", type: "audio", value: "" },
          label: { key: "10000147", type: "text", value: "描述" },
          desc: { key: "10000148", type: "text", value: "描述" }
        },
        voices7: {
          source: { key: "10000149", type: "audio", value: "" },
          label: { key: "10000150", type: "text", value: "描述" },
          desc: { key: "10000151", type: "text", value: "描述" }
        },
        voices8: {
          source: { key: "10000152", type: "audio", value: "" },
          label: { key: "10000153", type: "text", value: "描述" },
          desc: { key: "10000154", type: "text", value: "描述" }
        },
        voices9: {
          source: { key: "10000169", type: "audio", value: "" },
          label: { key: "10000170", type: "text", value: "描述" },
          desc: { key: "10000171", type: "text", value: "描述" }
        },
        voices10: {
          source: { key: "10000172", type: "audio", value: "" },
          label: { key: "10000173", type: "text", value: "描述" },
          desc: { key: "10000174", type: "text", value: "描述" }
        },
        voices11: {
          source: { key: "10000175", type: "audio", value: "" },
          label: { key: "10000176", type: "text", value: "描述" },
          desc: { key: "10000177", type: "text", value: "描述" }
        },
        voices12: {
          source: { key: "10000178", type: "audio", value: "" },
          label: { key: "10000179", type: "text", value: "描述" },
          desc: { key: "10000180", type: "text", value: "描述" }
        }
      },
      /** 阵容 */
      battle: {
        ql1: {
          ms: { key: "10000200", type: "text", value: "潜力1描述" },
          sp: { key: "10000212", type: "text", value: "潜力1SP数据抓取" },
          tp: { key: "10000213", type: "image", value: "潜力1图片" },
          tb: { key: "10000214", type: "image", value: "潜力1图标" },
          name: { key: "10000215", type: "text", value: "潜力1名称" }
        },
        ql2: {
          ms: { key: "10000204", type: "text", value: "潜力2描述" },
          sp: { key: "10000205", type: "text", value: "潜力2SP数据抓取" },
          tp: { key: "10000206", type: "image", value: "潜力2图片" },
          tb: { key: "10000207", type: "image", value: "潜力2图标" },
          name: { key: "10000216", type: "text", value: "潜力2名称" }
        },
        ql3: {
          ms: { key: "10000208", type: "text", value: "潜力3描述" },
          sp: { key: "10000209", type: "text", value: "潜力3SP数据抓取" },
          tp: { key: "10000210", type: "image", value: "潜力3图片" },
          tb: { key: "10000211", type: "image", value: "潜力3图标" },
          name: { key: "10000217", type: "text", value: "潜力3名称" }
        }
      },
      /** 抽卡 */
      vcard: {
        rate: { key: "10000230", type: "text", value: 0 },
        upRate: { key: "10000231", type: "text", value: 0 },
        /** 宠物 */
        pet: {
          pet1: {
            name: { key: "10000300", type: "text", value: "宠物1" },
            icon: { key: "10000301", type: "image", value: "" },
            skillImage: { key: "10000302", type: "image", value: "" },
            skillDesc: { key: "10000303", type: "text", value: "" },
            skillName: { key: "10000304", type: "text", value: "" },
            repel: { key: "10000325", type: "image", value: "" },
            damageType: { key: "10000326", type: "image", value: "" },
            attackRange: { key: "10000327", type: "text", value: "" }
          },
          pet2: {
            name: { key: "10000305", type: "text", value: "宠物2" },
            icon: { key: "10000306", type: "image", value: "" },
            skillImage: { key: "10000307", type: "image", value: "" },
            skillDesc: { key: "10000308", type: "text", value: "" },
            skillName: { key: "10000309", type: "text", value: "" },
            repel: { key: "10000328", type: "image", value: "" },
            damageType: { key: "10000329", type: "image", value: "" },
            attackRange: { key: "10000330", type: "text", value: "" }
          },
          pet3: {
            name: { key: "10000310", type: "text", value: "宠物3" },
            icon: { key: "10000311", type: "image", value: "" },
            skillImage: { key: "10000312", type: "image", value: "" },
            skillDesc: { key: "10000313", type: "text", value: "" },
            skillName: { key: "10000314", type: "text", value: "" },
            repel: { key: "10000331", type: "image", value: "" },
            damageType: { key: "10000332", type: "image", value: "" },
            attackRange: { key: "10000333", type: "text", value: "" }
          },
          pet4: {
            name: { key: "10000315", type: "text", value: "宠物4" },
            icon: { key: "10000316", type: "image", value: "" },
            skillImage: { key: "10000317", type: "image", value: "" },
            skillDesc: { key: "10000318", type: "text", value: "" },
            skillName: { key: "10000319", type: "text", value: "" },
            repel: { key: "10000334", type: "image", value: "" },
            damageType: { key: "10000335", type: "image", value: "" },
            attackRange: { key: "10000336", type: "text", value: "" }
          },
          pet5: {
            name: { key: "10000320", type: "text", value: "宠物5" },
            icon: { key: "10000321", type: "image", value: "" },
            skillImage: { key: "10000322", type: "image", value: "" },
            skillDesc: { key: "10000323", type: "text", value: "" },
            skillName: { key: "10000324", type: "text", value: "" },
            repel: { key: "10000337", type: "image", value: "" },
            damageType: { key: "10000338", type: "image", value: "" },
            attackRange: { key: "10000339", type: "text", value: "" }
          }
        }
      },
      // 皮肤测评
      evaluation: {
        cover: { key: "10000340", type: "image", value: defImg },
        link: { key: "10000341", type: "text", value: "" },
        title: { key: "10000342", type: "text", value: "皮肤测评标题" }
      }
    },
    style2: {
      name: { key: "20000202", type: "text", value: "名称" },
      tag: { key: "20000201", type: "text", value: "标签" },
      icon: { key: "20000081", type: "image", value: defImg },
      icon1: { key: "20000220", type: "image", value: defImg },
      icon2: { key: "20000221", type: "image", value: defImg },
      icon3: { key: "20000222", type: "image", value: defImg },
      icon4: { key: "20000223", type: "image", value: defImg },
      live2d: {
        source: {
          key: "20000082",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jh_source: {
          key: "20000352",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jn_source: {
          key: "20000353",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        cg_source: {
          key: "20000354",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        lh: { key: "20000185", type: "image", value: defImg }
      },
      skill: {
        icon: { key: "20000083", type: "image", value: defImg },
        name: { key: "20000084", type: "text", value: "技能" },
        video: { key: "20000184", type: "video", value: "" },
        desc: { key: "20000085", type: "text", value: "描述" },
        sp: { key: "20000086", type: "text", value: "消耗资源1" },
        cd: { key: "20000087", type: "text", value: "消耗资源2" },
        ability1: {
          name: { key: "20000181", type: "text", value: "绑定能力" },
          desc: { key: "20000088", type: "text", value: "描述" }
        },
        ability2: {
          name: { key: "20000182", type: "text", value: "共同能力" },
          desc: { key: "20000089", type: "text", value: "描述" }
        },
        attr1: {
          icon: { key: "20000090", type: "image", value: defImg },
          name: { key: "20000091", type: "text", value: "属性1" }
        },
        attr2: {
          icon: { key: "20000092", type: "image", value: defImg },
          name: { key: "20000093", type: "text", value: "属性2" }
        },
        attr3: {
          icon: { key: "20000094", type: "image", value: defImg },
          name: { key: "20000095", type: "text", value: "属性3" }
        },
        upgrade: {
          level1: {
            icon: { key: "20000096", type: "image", value: defImg },
            name: { key: "20000097", type: "text", value: "升级1" },
            sp: { key: "20000186", type: "text", value: 0 },
            cd: { key: "20000187", type: "text", value: 0 },
            desc: { key: "20000098", type: "text", value: "描述" }
          },
          level2: {
            icon: { key: "20000099", type: "image", value: defImg },
            name: { key: "20000100", type: "text", value: "升级2" },
            sp: { key: "20000188", type: "text", value: 0 },
            cd: { key: "20000189", type: "text", value: 0 },
            desc: { key: "20000101", type: "text", value: "描述" }
          },
          level3: {
            icon: { key: "20000102", type: "image", value: defImg },
            name: { key: "20000103", type: "text", value: "升级3" },
            sp: { key: "20000190", type: "text", value: 0 },
            cd: { key: "20000191", type: "text", value: 0 },
            desc: { key: "20000104", type: "text", value: "描述" }
          },
          level4: {
            icon: { key: "20000155", type: "image", value: defImg },
            name: { key: "20000156", type: "text", value: "升级4" },
            sp: { key: "20000192", type: "text", value: 0 },
            cd: { key: "20000193", type: "text", value: 0 },
            desc: { key: "20000157", type: "text", value: "描述" }
          },
          level5: {
            icon: { key: "20000158", type: "image", value: defImg },
            name: { key: "20000159", type: "text", value: "升级5" },
            sp: { key: "20000194", type: "text", value: 0 },
            cd: { key: "20000195", type: "text", value: 0 },
            desc: { key: "20000160", type: "text", value: "描述" }
          },
          level6: {
            icon: { key: "20000161", type: "image", value: defImg },
            name: { key: "20000162", type: "text", value: "升级6" },
            sp: { key: "20000196", type: "text", value: 0 },
            cd: { key: "20000197", type: "text", value: 0 },
            desc: { key: "20000163", type: "text", value: "描述" }
          },
          level7: {
            icon: { key: "20000164", type: "image", value: defImg },
            name: { key: "20000165", type: "text", value: "升级7" },
            sp: { key: "20000198", type: "text", value: 0 },
            cd: { key: "20000199", type: "text", value: 0 },
            desc: { key: "20000166", type: "text", value: "描述" }
          }
        },
        // 潜力
        potential: {
          item1: {
            icon: { key: "20000343", type: "image", value: defImg },
            desc: { key: "20000344", type: "text", value: "描述" },
            iconDesc: { key: "20000349", type: "image", value: defImg }
          },
          item2: {
            icon: { key: "20000345", type: "image", value: defImg },
            desc: { key: "20000346", type: "text", value: "描述" },
            iconDesc: { key: "20000350", type: "image", value: defImg }
          },
          item3: {
            icon: { key: "20000347", type: "image", value: defImg },
            desc: { key: "20000348", type: "text", value: "描述" },
            iconDesc: { key: "20000351", type: "image", value: defImg }
          }
        }
      },
      introduction: {
        slogn: { key: "20000105", type: "text", value: "简介" },
        nl: {
          label: { key: "20000106", type: "text", value: "年龄" },
          desc: { key: "20000107", type: "text", value: "描述" }
        },
        sg: {
          label: { key: "20000108", type: "text", value: "身高" },
          desc: { key: "20000109", type: "text", value: "描述" }
        },
        sr: {
          label: { key: "20000167", type: "text", value: "生日" },
          desc: { key: "20000168", type: "text", value: "描述" }
        },
        xq: {
          label: { key: "20000110", type: "text", value: "兴趣" },
          desc: { key: "20000111", type: "text", value: "描述" }
        },
        tyddx: {
          label: { key: "20000112", type: "text", value: "讨厌的东西" },
          desc: { key: "20000113", type: "text", value: "描述" }
        },
        sszw: {
          label: { key: "20000114", type: "text", value: "所属/职位" },
          desc: { key: "20000115", type: "text", value: "描述" }
        },
        xhddx: {
          label: { key: "20000116", type: "text", value: "喜欢的东西" },
          desc: { key: "20000117", type: "text", value: "描述" }
        },
        zxddx: {
          label: { key: "20000118", type: "text", value: "珍惜的东西" },
          desc: { key: "20000119", type: "text", value: "描述" }
        },
        cw1: {
          label: { key: "20000120", type: "text", value: "传闻1" },
          desc: { key: "20000121", type: "text", value: "描述" }
        },
        cw2: {
          label: { key: "20000122", type: "text", value: "传闻2" },
          desc: { key: "20000123", type: "text", value: "描述" }
        }
      },
      voices: {
        voices1: {
          source: { key: "20000124", type: "audio", value: "" },
          label: { key: "20000125", type: "text", value: "描述" },
          desc: { key: "20000126", type: "text", value: "描述" }
        },
        voices2: {
          source: { key: "20000127", type: "audio", value: "" },
          label: { key: "20000128", type: "text", value: "描述" },
          desc: { key: "20000129", type: "text", value: "描述" }
        },
        voices3: {
          source: { key: "20000130", type: "audio", value: "" },
          label: { key: "20000131", type: "text", value: "描述" },
          desc: { key: "20000132", type: "text", value: "描述" }
        },
        voices4: {
          source: { key: "20000140", type: "audio", value: "" },
          label: { key: "20000141", type: "text", value: "描述" },
          desc: { key: "20000142", type: "text", value: "描述" }
        },
        voices5: {
          source: { key: "20000143", type: "audio", value: "" },
          label: { key: "20000144", type: "text", value: "描述" },
          desc: { key: "20000145", type: "text", value: "描述" }
        },
        voices6: {
          source: { key: "20000146", type: "audio", value: "" },
          label: { key: "20000147", type: "text", value: "描述" },
          desc: { key: "20000148", type: "text", value: "描述" }
        },
        voices7: {
          source: { key: "20000149", type: "audio", value: "" },
          label: { key: "20000150", type: "text", value: "描述" },
          desc: { key: "20000151", type: "text", value: "描述" }
        },
        voices8: {
          source: { key: "20000152", type: "audio", value: "" },
          label: { key: "20000153", type: "text", value: "描述" },
          desc: { key: "20000154", type: "text", value: "描述" }
        },
        voices9: {
          source: { key: "20000169", type: "audio", value: "" },
          label: { key: "20000170", type: "text", value: "描述" },
          desc: { key: "20000171", type: "text", value: "描述" }
        },
        voices10: {
          source: { key: "20000172", type: "audio", value: "" },
          label: { key: "20000173", type: "text", value: "描述" },
          desc: { key: "20000174", type: "text", value: "描述" }
        },
        voices11: {
          source: { key: "20000175", type: "audio", value: "" },
          label: { key: "20000176", type: "text", value: "描述" },
          desc: { key: "20000177", type: "text", value: "描述" }
        },
        voices12: {
          source: { key: "20000178", type: "audio", value: "" },
          label: { key: "20000179", type: "text", value: "描述" },
          desc: { key: "20000180", type: "text", value: "描述" }
        }
      },
      /** 阵容 */
      battle: {
        ql1: {
          ms: { key: "20000200", type: "text", value: "潜力1描述" },
          sp: { key: "20000212", type: "text", value: "潜力1SP数据抓取" },
          tp: { key: "20000213", type: "image", value: "潜力1图片" },
          tb: { key: "20000214", type: "image", value: "潜力1图标" },
          name: { key: "20000215", type: "text", value: "潜力1名称" }
        },
        ql2: {
          ms: { key: "20000204", type: "text", value: "潜力2描述" },
          sp: { key: "20000205", type: "text", value: "潜力2SP数据抓取" },
          tp: { key: "20000206", type: "image", value: "潜力2图片" },
          tb: { key: "20000207", type: "image", value: "潜力2图标" },
          name: { key: "20000216", type: "text", value: "潜力2名称" }
        },
        ql3: {
          ms: { key: "20000208", type: "text", value: "潜力3描述" },
          sp: { key: "20000209", type: "text", value: "潜力3SP数据抓取" },
          tp: { key: "20000210", type: "image", value: "潜力3图片" },
          tb: { key: "20000211", type: "image", value: "潜力3图标" },
          name: { key: "20000217", type: "text", value: "潜力3名称" }
        }
      },
      /** 抽卡 */
      vcard: {
        rate: { key: "20000230", type: "text", value: 0 },
        upRate: { key: "20000231", type: "text", value: 0 },
        /** 宠物 */
        pet: {
          pet1: {
            name: { key: "20000300", type: "text", value: "宠物1" },
            icon: { key: "20000301", type: "image", value: "" },
            skillImage: { key: "20000302", type: "image", value: "" },
            skillDesc: { key: "20000303", type: "text", value: "" },
            skillName: { key: "20000304", type: "text", value: "" },
            repel: { key: "20000325", type: "image", value: "" },
            damageType: { key: "20000326", type: "image", value: "" },
            attackRange: { key: "20000327", type: "text", value: "" }
          },
          pet2: {
            name: { key: "20000305", type: "text", value: "宠物2" },
            icon: { key: "20000306", type: "image", value: "" },
            skillImage: { key: "20000307", type: "image", value: "" },
            skillDesc: { key: "20000308", type: "text", value: "" },
            skillName: { key: "20000309", type: "text", value: "" },
            repel: { key: "20000328", type: "image", value: "" },
            damageType: { key: "20000329", type: "image", value: "" },
            attackRange: { key: "20000330", type: "text", value: "" }
          },
          pet3: {
            name: { key: "20000310", type: "text", value: "宠物3" },
            icon: { key: "20000311", type: "image", value: "" },
            skillImage: { key: "20000312", type: "image", value: "" },
            skillDesc: { key: "20000313", type: "text", value: "" },
            skillName: { key: "20000314", type: "text", value: "" },
            repel: { key: "20000331", type: "image", value: "" },
            damageType: { key: "20000332", type: "image", value: "" },
            attackRange: { key: "20000333", type: "text", value: "" }
          },
          pet4: {
            name: { key: "20000315", type: "text", value: "宠物4" },
            icon: { key: "20000316", type: "image", value: "" },
            skillImage: { key: "20000317", type: "image", value: "" },
            skillDesc: { key: "20000318", type: "text", value: "" },
            skillName: { key: "20000319", type: "text", value: "" },
            repel: { key: "20000334", type: "image", value: "" },
            damageType: { key: "20000335", type: "image", value: "" },
            attackRange: { key: "20000336", type: "text", value: "" }
          },
          pet5: {
            name: { key: "20000320", type: "text", value: "宠物5" },
            icon: { key: "20000321", type: "image", value: "" },
            skillImage: { key: "20000322", type: "image", value: "" },
            skillDesc: { key: "20000323", type: "text", value: "" },
            skillName: { key: "20000324", type: "text", value: "" },
            repel: { key: "20000337", type: "image", value: "" },
            damageType: { key: "20000338", type: "image", value: "" },
            attackRange: { key: "20000339", type: "text", value: "" }
          }
        }
      },
      // 皮肤测评
      evaluation: {
        cover: { key: "20000340", type: "image", value: defImg },
        link: { key: "20000341", type: "text", value: "" },
        title: { key: "20000342", type: "text", value: "皮肤测评标题" }
      }
    },
    style3: {
      name: { key: "30000202", type: "text", value: "名称" },
      tag: { key: "30000201", type: "text", value: "标签" },
      icon: { key: "30000081", type: "image", value: defImg },
      icon1: { key: "30000220", type: "image", value: defImg },
      icon2: { key: "30000221", type: "image", value: defImg },
      icon3: { key: "30000222", type: "image", value: defImg },
      icon4: { key: "30000223", type: "image", value: defImg },
      live2d: {
        source: {
          key: "30000082",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jh_source: {
          key: "30000352",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jn_source: {
          key: "30000353",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        cg_source: {
          key: "30000354",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        lh: { key: "30000185", type: "image", value: defImg }
      },
      skill: {
        icon: { key: "30000083", type: "image", value: defImg },
        name: { key: "30000084", type: "text", value: "技能" },
        video: { key: "30000184", type: "video", value: "" },
        desc: { key: "30000085", type: "text", value: "描述" },
        sp: { key: "30000086", type: "text", value: "消耗资源1" },
        cd: { key: "30000087", type: "text", value: "消耗资源2" },
        ability1: {
          name: { key: "30000181", type: "text", value: "绑定能力" },
          desc: { key: "30000088", type: "text", value: "描述" }
        },
        ability2: {
          name: { key: "30000182", type: "text", value: "共同能力" },
          desc: { key: "30000089", type: "text", value: "描述" }
        },
        attr1: {
          icon: { key: "30000090", type: "image", value: defImg },
          name: { key: "30000091", type: "text", value: "属性1" }
        },
        attr2: {
          icon: { key: "30000092", type: "image", value: defImg },
          name: { key: "30000093", type: "text", value: "属性2" }
        },
        attr3: {
          icon: { key: "30000094", type: "image", value: defImg },
          name: { key: "30000095", type: "text", value: "属性3" }
        },
        upgrade: {
          level1: {
            icon: { key: "30000096", type: "image", value: defImg },
            name: { key: "30000097", type: "text", value: "升级1" },
            sp: { key: "30000186", type: "text", value: 0 },
            cd: { key: "30000187", type: "text", value: 0 },
            desc: { key: "30000098", type: "text", value: "描述" }
          },
          level2: {
            icon: { key: "30000099", type: "image", value: defImg },
            name: { key: "30000100", type: "text", value: "升级2" },
            sp: { key: "30000188", type: "text", value: 0 },
            cd: { key: "30000189", type: "text", value: 0 },
            desc: { key: "30000101", type: "text", value: "描述" }
          },
          level3: {
            icon: { key: "30000102", type: "image", value: defImg },
            name: { key: "30000103", type: "text", value: "升级3" },
            sp: { key: "30000190", type: "text", value: 0 },
            cd: { key: "30000191", type: "text", value: 0 },
            desc: { key: "30000104", type: "text", value: "描述" }
          },
          level4: {
            icon: { key: "30000155", type: "image", value: defImg },
            name: { key: "30000156", type: "text", value: "升级4" },
            sp: { key: "30000192", type: "text", value: 0 },
            cd: { key: "30000193", type: "text", value: 0 },
            desc: { key: "30000157", type: "text", value: "描述" }
          },
          level5: {
            icon: { key: "30000158", type: "image", value: defImg },
            name: { key: "30000159", type: "text", value: "升级5" },
            sp: { key: "30000194", type: "text", value: 0 },
            cd: { key: "30000195", type: "text", value: 0 },
            desc: { key: "30000160", type: "text", value: "描述" }
          },
          level6: {
            icon: { key: "30000161", type: "image", value: defImg },
            name: { key: "30000162", type: "text", value: "升级6" },
            sp: { key: "30000196", type: "text", value: 0 },
            cd: { key: "30000197", type: "text", value: 0 },
            desc: { key: "30000163", type: "text", value: "描述" }
          },
          level7: {
            icon: { key: "30000164", type: "image", value: defImg },
            name: { key: "30000165", type: "text", value: "升级7" },
            sp: { key: "30000198", type: "text", value: 0 },
            cd: { key: "30000199", type: "text", value: 0 },
            desc: { key: "30000166", type: "text", value: "描述" }
          }
        },
        // 潜力
        potential: {
          item1: {
            icon: { key: "30000343", type: "image", value: defImg },
            desc: { key: "30000344", type: "text", value: "描述" },
            iconDesc: { key: "30000349", type: "image", value: defImg }
          },
          item2: {
            icon: { key: "30000345", type: "image", value: defImg },
            desc: { key: "30000346", type: "text", value: "描述" },
            iconDesc: { key: "30000350", type: "image", value: defImg }
          },
          item3: {
            icon: { key: "30000347", type: "image", value: defImg },
            desc: { key: "30000348", type: "text", value: "描述" },
            iconDesc: { key: "30000351", type: "image", value: defImg }
          }
        }
      },
      introduction: {
        slogn: { key: "30000105", type: "text", value: "简介" },
        nl: {
          label: { key: "30000106", type: "text", value: "年龄" },
          desc: { key: "30000107", type: "text", value: "描述" }
        },
        sg: {
          label: { key: "30000108", type: "text", value: "身高" },
          desc: { key: "30000109", type: "text", value: "描述" }
        },
        sr: {
          label: { key: "30000167", type: "text", value: "生日" },
          desc: { key: "30000168", type: "text", value: "描述" }
        },
        xq: {
          label: { key: "30000110", type: "text", value: "兴趣" },
          desc: { key: "30000111", type: "text", value: "描述" }
        },
        tyddx: {
          label: { key: "30000112", type: "text", value: "讨厌的东西" },
          desc: { key: "30000113", type: "text", value: "描述" }
        },
        sszw: {
          label: { key: "30000114", type: "text", value: "所属/职位" },
          desc: { key: "30000115", type: "text", value: "描述" }
        },
        xhddx: {
          label: { key: "30000116", type: "text", value: "喜欢的东西" },
          desc: { key: "30000117", type: "text", value: "描述" }
        },
        zxddx: {
          label: { key: "30000118", type: "text", value: "珍惜的东西" },
          desc: { key: "30000119", type: "text", value: "描述" }
        },
        cw1: {
          label: { key: "30000120", type: "text", value: "传闻1" },
          desc: { key: "30000121", type: "text", value: "描述" }
        },
        cw2: {
          label: { key: "30000122", type: "text", value: "传闻2" },
          desc: { key: "30000123", type: "text", value: "描述" }
        }
      },
      voices: {
        voices1: {
          source: { key: "30000124", type: "audio", value: "" },
          label: { key: "30000125", type: "text", value: "描述" },
          desc: { key: "30000126", type: "text", value: "描述" }
        },
        voices2: {
          source: { key: "30000127", type: "audio", value: "" },
          label: { key: "30000128", type: "text", value: "描述" },
          desc: { key: "30000129", type: "text", value: "描述" }
        },
        voices3: {
          source: { key: "30000130", type: "audio", value: "" },
          label: { key: "30000131", type: "text", value: "描述" },
          desc: { key: "30000132", type: "text", value: "描述" }
        },
        voices4: {
          source: { key: "30000140", type: "audio", value: "" },
          label: { key: "30000141", type: "text", value: "描述" },
          desc: { key: "30000142", type: "text", value: "描述" }
        },
        voices5: {
          source: { key: "30000143", type: "audio", value: "" },
          label: { key: "30000144", type: "text", value: "描述" },
          desc: { key: "30000145", type: "text", value: "描述" }
        },
        voices6: {
          source: { key: "30000146", type: "audio", value: "" },
          label: { key: "30000147", type: "text", value: "描述" },
          desc: { key: "30000148", type: "text", value: "描述" }
        },
        voices7: {
          source: { key: "30000149", type: "audio", value: "" },
          label: { key: "30000150", type: "text", value: "描述" },
          desc: { key: "30000151", type: "text", value: "描述" }
        },
        voices8: {
          source: { key: "30000152", type: "audio", value: "" },
          label: { key: "30000153", type: "text", value: "描述" },
          desc: { key: "30000154", type: "text", value: "描述" }
        },
        voices9: {
          source: { key: "30000169", type: "audio", value: "" },
          label: { key: "30000170", type: "text", value: "描述" },
          desc: { key: "30000171", type: "text", value: "描述" }
        },
        voices10: {
          source: { key: "30000172", type: "audio", value: "" },
          label: { key: "30000173", type: "text", value: "描述" },
          desc: { key: "30000174", type: "text", value: "描述" }
        },
        voices11: {
          source: { key: "30000175", type: "audio", value: "" },
          label: { key: "30000176", type: "text", value: "描述" },
          desc: { key: "30000177", type: "text", value: "描述" }
        },
        voices12: {
          source: { key: "30000178", type: "audio", value: "" },
          label: { key: "30000179", type: "text", value: "描述" },
          desc: { key: "30000180", type: "text", value: "描述" }
        }
      },
      /** 阵容 */
      battle: {
        ql1: {
          ms: { key: "30000200", type: "text", value: "潜力1描述" },
          sp: { key: "30000212", type: "text", value: "潜力1SP数据抓取" },
          tp: { key: "30000213", type: "image", value: "潜力1图片" },
          tb: { key: "30000214", type: "image", value: "潜力1图标" },
          name: { key: "30000215", type: "text", value: "潜力1名称" }
        },
        ql2: {
          ms: { key: "30000204", type: "text", value: "潜力2描述" },
          sp: { key: "30000205", type: "text", value: "潜力2SP数据抓取" },
          tp: { key: "30000206", type: "image", value: "潜力2图片" },
          tb: { key: "30000207", type: "image", value: "潜力2图标" },
          name: { key: "30000216", type: "text", value: "潜力2名称" }
        },
        ql3: {
          ms: { key: "30000208", type: "text", value: "潜力3描述" },
          sp: { key: "30000209", type: "text", value: "潜力3SP数据抓取" },
          tp: { key: "30000210", type: "image", value: "潜力3图片" },
          tb: { key: "30000211", type: "image", value: "潜力3图标" },
          name: { key: "30000217", type: "text", value: "潜力3名称" }
        }
      },
      /** 抽卡 */
      vcard: {
        rate: { key: "30000230", type: "text", value: 0 },
        upRate: { key: "30000231", type: "text", value: 0 },
        /** 宠物 */
        pet: {
          pet1: {
            name: { key: "30000300", type: "text", value: "宠物1" },
            icon: { key: "30000301", type: "image", value: "" },
            skillImage: { key: "30000302", type: "image", value: "" },
            skillDesc: { key: "30000303", type: "text", value: "" },
            skillName: { key: "30000304", type: "text", value: "" },
            repel: { key: "30000325", type: "image", value: "" },
            damageType: { key: "30000326", type: "image", value: "" },
            attackRange: { key: "30000327", type: "text", value: "" }
          },
          pet2: {
            name: { key: "30000305", type: "text", value: "宠物2" },
            icon: { key: "30000306", type: "image", value: "" },
            skillImage: { key: "30000307", type: "image", value: "" },
            skillDesc: { key: "30000308", type: "text", value: "" },
            skillName: { key: "30000309", type: "text", value: "" },
            repel: { key: "30000328", type: "image", value: "" },
            damageType: { key: "30000329", type: "image", value: "" },
            attackRange: { key: "30000330", type: "text", value: "" }
          },
          pet3: {
            name: { key: "30000310", type: "text", value: "宠物3" },
            icon: { key: "30000311", type: "image", value: "" },
            skillImage: { key: "30000312", type: "image", value: "" },
            skillDesc: { key: "30000313", type: "text", value: "" },
            skillName: { key: "30000314", type: "text", value: "" },
            repel: { key: "30000331", type: "image", value: "" },
            damageType: { key: "30000332", type: "image", value: "" },
            attackRange: { key: "30000333", type: "text", value: "" }
          },
          pet4: {
            name: { key: "30000315", type: "text", value: "宠物4" },
            icon: { key: "30000316", type: "image", value: "" },
            skillImage: { key: "30000317", type: "image", value: "" },
            skillDesc: { key: "30000318", type: "text", value: "" },
            skillName: { key: "30000319", type: "text", value: "" },
            repel: { key: "30000334", type: "image", value: "" },
            damageType: { key: "30000335", type: "image", value: "" },
            attackRange: { key: "30000336", type: "text", value: "" }
          },
          pet5: {
            name: { key: "30000320", type: "text", value: "宠物5" },
            icon: { key: "30000321", type: "image", value: "" },
            skillImage: { key: "30000322", type: "image", value: "" },
            skillDesc: { key: "30000323", type: "text", value: "" },
            skillName: { key: "30000324", type: "text", value: "" },
            repel: { key: "30000337", type: "image", value: "" },
            damageType: { key: "30000338", type: "image", value: "" },
            attackRange: { key: "30000339", type: "text", value: "" }
          }
        }
      },
      // 皮肤测评
      evaluation: {
        cover: { key: "30000340", type: "image", value: defImg },
        link: { key: "30000341", type: "text", value: "" },
        title: { key: "30000342", type: "text", value: "皮肤测评标题" }
      }
    },
    style4: {
      name: { key: "40000202", type: "text", value: "名称" },
      tag: { key: "40000201", type: "text", value: "标签" },
      icon: { key: "40000081", type: "image", value: defImg },
      icon1: { key: "40000220", type: "image", value: defImg },
      icon2: { key: "40000221", type: "image", value: defImg },
      icon3: { key: "40000222", type: "image", value: defImg },
      icon4: { key: "40000223", type: "image", value: defImg },
      live2d: {
        source: {
          key: "40000082",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jh_source: {
          key: "40000352",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jn_source: {
          key: "40000353",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        cg_source: {
          key: "40000354",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        lh: { key: "40000185", type: "image", value: defImg }
      },
      skill: {
        icon: { key: "40000083", type: "image", value: defImg },
        name: { key: "40000084", type: "text", value: "技能" },
        video: { key: "40000184", type: "video", value: "" },
        desc: { key: "40000085", type: "text", value: "描述" },
        sp: { key: "40000086", type: "text", value: "消耗资源1" },
        cd: { key: "40000087", type: "text", value: "消耗资源2" },
        ability1: {
          name: { key: "40000181", type: "text", value: "绑定能力" },
          desc: { key: "40000088", type: "text", value: "描述" }
        },
        ability2: {
          name: { key: "40000182", type: "text", value: "共同能力" },
          desc: { key: "40000089", type: "text", value: "描述" }
        },
        attr1: {
          icon: { key: "40000090", type: "image", value: defImg },
          name: { key: "40000091", type: "text", value: "属性1" }
        },
        attr2: {
          icon: { key: "40000092", type: "image", value: defImg },
          name: { key: "40000093", type: "text", value: "属性2" }
        },
        attr3: {
          icon: { key: "40000094", type: "image", value: defImg },
          name: { key: "40000095", type: "text", value: "属性3" }
        },
        upgrade: {
          level1: {
            icon: { key: "40000096", type: "image", value: defImg },
            name: { key: "40000097", type: "text", value: "升级1" },
            sp: { key: "40000186", type: "text", value: 0 },
            cd: { key: "40000187", type: "text", value: 0 },
            desc: { key: "40000098", type: "text", value: "描述" }
          },
          level2: {
            icon: { key: "40000099", type: "image", value: defImg },
            name: { key: "40000100", type: "text", value: "升级2" },
            sp: { key: "40000188", type: "text", value: 0 },
            cd: { key: "40000189", type: "text", value: 0 },
            desc: { key: "40000101", type: "text", value: "描述" }
          },
          level3: {
            icon: { key: "40000102", type: "image", value: defImg },
            name: { key: "40000103", type: "text", value: "升级3" },
            sp: { key: "40000190", type: "text", value: 0 },
            cd: { key: "40000191", type: "text", value: 0 },
            desc: { key: "40000104", type: "text", value: "描述" }
          },
          level4: {
            icon: { key: "40000155", type: "image", value: defImg },
            name: { key: "40000156", type: "text", value: "升级4" },
            sp: { key: "40000192", type: "text", value: 0 },
            cd: { key: "40000193", type: "text", value: 0 },
            desc: { key: "40000157", type: "text", value: "描述" }
          },
          level5: {
            icon: { key: "40000158", type: "image", value: defImg },
            name: { key: "40000159", type: "text", value: "升级5" },
            sp: { key: "40000194", type: "text", value: 0 },
            cd: { key: "40000195", type: "text", value: 0 },
            desc: { key: "40000160", type: "text", value: "描述" }
          },
          level6: {
            icon: { key: "40000161", type: "image", value: defImg },
            name: { key: "40000162", type: "text", value: "升级6" },
            sp: { key: "40000196", type: "text", value: 0 },
            cd: { key: "40000197", type: "text", value: 0 },
            desc: { key: "40000163", type: "text", value: "描述" }
          },
          level7: {
            icon: { key: "40000164", type: "image", value: defImg },
            name: { key: "40000165", type: "text", value: "升级7" },
            sp: { key: "40000198", type: "text", value: 0 },
            cd: { key: "40000199", type: "text", value: 0 },
            desc: { key: "40000166", type: "text", value: "描述" }
          }
        },
        // 潜力
        potential: {
          item1: {
            icon: { key: "40000343", type: "image", value: defImg },
            desc: { key: "40000344", type: "text", value: "描述" },
            iconDesc: { key: "40000349", type: "image", value: defImg }
          },
          item2: {
            icon: { key: "40000345", type: "image", value: defImg },
            desc: { key: "40000346", type: "text", value: "描述" },
            iconDesc: { key: "40000350", type: "image", value: defImg }
          },
          item3: {
            icon: { key: "40000347", type: "image", value: defImg },
            desc: { key: "40000348", type: "text", value: "描述" },
            iconDesc: { key: "40000351", type: "image", value: defImg }
          }
        }
      },
      introduction: {
        slogn: { key: "40000105", type: "text", value: "简介" },
        nl: {
          label: { key: "40000106", type: "text", value: "年龄" },
          desc: { key: "40000107", type: "text", value: "描述" }
        },
        sg: {
          label: { key: "40000108", type: "text", value: "身高" },
          desc: { key: "40000109", type: "text", value: "描述" }
        },
        sr: {
          label: { key: "40000167", type: "text", value: "生日" },
          desc: { key: "40000168", type: "text", value: "描述" }
        },
        xq: {
          label: { key: "40000110", type: "text", value: "兴趣" },
          desc: { key: "40000111", type: "text", value: "描述" }
        },
        tyddx: {
          label: { key: "40000112", type: "text", value: "讨厌的东西" },
          desc: { key: "40000113", type: "text", value: "描述" }
        },
        sszw: {
          label: { key: "40000114", type: "text", value: "所属/职位" },
          desc: { key: "40000115", type: "text", value: "描述" }
        },
        xhddx: {
          label: { key: "40000116", type: "text", value: "喜欢的东西" },
          desc: { key: "40000117", type: "text", value: "描述" }
        },
        zxddx: {
          label: { key: "40000118", type: "text", value: "珍惜的东西" },
          desc: { key: "40000119", type: "text", value: "描述" }
        },
        cw1: {
          label: { key: "40000120", type: "text", value: "传闻1" },
          desc: { key: "40000121", type: "text", value: "描述" }
        },
        cw2: {
          label: { key: "40000122", type: "text", value: "传闻2" },
          desc: { key: "40000123", type: "text", value: "描述" }
        }
      },
      voices: {
        voices1: {
          source: { key: "40000124", type: "audio", value: "" },
          label: { key: "40000125", type: "text", value: "描述" },
          desc: { key: "40000126", type: "text", value: "描述" }
        },
        voices2: {
          source: { key: "40000127", type: "audio", value: "" },
          label: { key: "40000128", type: "text", value: "描述" },
          desc: { key: "40000129", type: "text", value: "描述" }
        },
        voices3: {
          source: { key: "40000130", type: "audio", value: "" },
          label: { key: "40000131", type: "text", value: "描述" },
          desc: { key: "40000132", type: "text", value: "描述" }
        },
        voices4: {
          source: { key: "40000140", type: "audio", value: "" },
          label: { key: "40000141", type: "text", value: "描述" },
          desc: { key: "40000142", type: "text", value: "描述" }
        },
        voices5: {
          source: { key: "40000143", type: "audio", value: "" },
          label: { key: "40000144", type: "text", value: "描述" },
          desc: { key: "40000145", type: "text", value: "描述" }
        },
        voices6: {
          source: { key: "40000146", type: "audio", value: "" },
          label: { key: "40000147", type: "text", value: "描述" },
          desc: { key: "40000148", type: "text", value: "描述" }
        },
        voices7: {
          source: { key: "40000149", type: "audio", value: "" },
          label: { key: "40000150", type: "text", value: "描述" },
          desc: { key: "40000151", type: "text", value: "描述" }
        },
        voices8: {
          source: { key: "40000152", type: "audio", value: "" },
          label: { key: "40000153", type: "text", value: "描述" },
          desc: { key: "40000154", type: "text", value: "描述" }
        },
        voices9: {
          source: { key: "40000169", type: "audio", value: "" },
          label: { key: "40000170", type: "text", value: "描述" },
          desc: { key: "40000171", type: "text", value: "描述" }
        },
        voices10: {
          source: { key: "40000172", type: "audio", value: "" },
          label: { key: "40000173", type: "text", value: "描述" },
          desc: { key: "40000174", type: "text", value: "描述" }
        },
        voices11: {
          source: { key: "40000175", type: "audio", value: "" },
          label: { key: "40000176", type: "text", value: "描述" },
          desc: { key: "40000177", type: "text", value: "描述" }
        },
        voices12: {
          source: { key: "40000178", type: "audio", value: "" },
          label: { key: "40000179", type: "text", value: "描述" },
          desc: { key: "40000180", type: "text", value: "描述" }
        }
      },
      /** 阵容 */
      battle: {
        ql1: {
          ms: { key: "40000200", type: "text", value: "潜力1描述" },
          sp: { key: "40000212", type: "text", value: "潜力1SP数据抓取" },
          tp: { key: "40000213", type: "image", value: "潜力1图片" },
          tb: { key: "40000214", type: "image", value: "潜力1图标" },
          name: { key: "40000215", type: "text", value: "潜力1名称" }
        },
        ql2: {
          ms: { key: "40000204", type: "text", value: "潜力2描述" },
          sp: { key: "40000205", type: "text", value: "潜力2SP数据抓取" },
          tp: { key: "40000206", type: "image", value: "潜力2图片" },
          tb: { key: "40000207", type: "image", value: "潜力2图标" },
          name: { key: "40000216", type: "text", value: "潜力2名称" }
        },
        ql3: {
          ms: { key: "40000208", type: "text", value: "潜力3描述" },
          sp: { key: "40000209", type: "text", value: "潜力3SP数据抓取" },
          tp: { key: "40000210", type: "image", value: "潜力3图片" },
          tb: { key: "40000211", type: "image", value: "潜力3图标" },
          name: { key: "40000217", type: "text", value: "潜力3名称" }
        }
      },
      /** 抽卡 */
      vcard: {
        rate: { key: "40000230", type: "text", value: 0 },
        upRate: { key: "40000231", type: "text", value: 0 },
        /** 宠物 */
        pet: {
          pet1: {
            name: { key: "40000300", type: "text", value: "宠物1" },
            icon: { key: "40000301", type: "image", value: "" },
            skillImage: { key: "40000302", type: "image", value: "" },
            skillDesc: { key: "40000303", type: "text", value: "" },
            skillName: { key: "40000304", type: "text", value: "" },
            repel: { key: "40000325", type: "image", value: "" },
            damageType: { key: "40000326", type: "image", value: "" },
            attackRange: { key: "40000327", type: "text", value: "" }
          },
          pet2: {
            name: { key: "40000305", type: "text", value: "宠物2" },
            icon: { key: "40000306", type: "image", value: "" },
            skillImage: { key: "40000307", type: "image", value: "" },
            skillDesc: { key: "40000308", type: "text", value: "" },
            skillName: { key: "40000309", type: "text", value: "" },
            repel: { key: "40000328", type: "image", value: "" },
            damageType: { key: "40000329", type: "image", value: "" },
            attackRange: { key: "40000330", type: "text", value: "" }
          },
          pet3: {
            name: { key: "40000310", type: "text", value: "宠物3" },
            icon: { key: "40000311", type: "image", value: "" },
            skillImage: { key: "40000312", type: "image", value: "" },
            skillDesc: { key: "40000313", type: "text", value: "" },
            skillName: { key: "40000314", type: "text", value: "" },
            repel: { key: "40000331", type: "image", value: "" },
            damageType: { key: "40000332", type: "image", value: "" },
            attackRange: { key: "40000333", type: "text", value: "" }
          },
          pet4: {
            name: { key: "40000315", type: "text", value: "宠物4" },
            icon: { key: "40000316", type: "image", value: "" },
            skillImage: { key: "40000317", type: "image", value: "" },
            skillDesc: { key: "40000318", type: "text", value: "" },
            skillName: { key: "40000319", type: "text", value: "" },
            repel: { key: "40000334", type: "image", value: "" },
            damageType: { key: "40000335", type: "image", value: "" },
            attackRange: { key: "40000336", type: "text", value: "" }
          },
          pet5: {
            name: { key: "40000320", type: "text", value: "宠物5" },
            icon: { key: "40000321", type: "image", value: "" },
            skillImage: { key: "40000322", type: "image", value: "" },
            skillDesc: { key: "40000323", type: "text", value: "" },
            skillName: { key: "40000324", type: "text", value: "" },
            repel: { key: "40000337", type: "image", value: "" },
            damageType: { key: "40000338", type: "image", value: "" },
            attackRange: { key: "40000339", type: "text", value: "" }
          }
        }
      },
      // 皮肤测评
      evaluation: {
        cover: { key: "40000340", type: "image", value: defImg },
        link: { key: "40000341", type: "text", value: "" },
        title: { key: "40000342", type: "text", value: "皮肤测评标题" }
      }
    },
    style5: {
      name: { key: "50000202", type: "text", value: "名称" },
      tag: { key: "50000201", type: "text", value: "标签" },
      icon: { key: "50000081", type: "image", value: defImg },
      icon1: { key: "50000220", type: "image", value: defImg },
      icon2: { key: "50000221", type: "image", value: defImg },
      icon3: { key: "50000222", type: "image", value: defImg },
      icon4: { key: "50000223", type: "image", value: defImg },
      live2d: {
        source: {
          key: "50000082",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jh_source: {
          key: "50000352",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jn_source: {
          key: "50000353",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        cg_source: {
          key: "50000354",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        lh: { key: "50000185", type: "image", value: defImg }
      },
      skill: {
        icon: { key: "50000083", type: "image", value: defImg },
        name: { key: "50000084", type: "text", value: "技能" },
        video: { key: "50000184", type: "video", value: "" },
        desc: { key: "50000085", type: "text", value: "描述" },
        sp: { key: "50000086", type: "text", value: "消耗资源1" },
        cd: { key: "50000087", type: "text", value: "消耗资源2" },
        ability1: {
          name: { key: "50000181", type: "text", value: "绑定能力" },
          desc: { key: "50000088", type: "text", value: "描述" }
        },
        ability2: {
          name: { key: "50000182", type: "text", value: "共同能力" },
          desc: { key: "50000089", type: "text", value: "描述" }
        },
        attr1: {
          icon: { key: "50000090", type: "image", value: defImg },
          name: { key: "50000091", type: "text", value: "属性1" }
        },
        attr2: {
          icon: { key: "50000092", type: "image", value: defImg },
          name: { key: "50000093", type: "text", value: "属性2" }
        },
        attr3: {
          icon: { key: "50000094", type: "image", value: defImg },
          name: { key: "50000095", type: "text", value: "属性3" }
        },
        upgrade: {
          level1: {
            icon: { key: "50000096", type: "image", value: defImg },
            name: { key: "50000097", type: "text", value: "升级1" },
            sp: { key: "50000186", type: "text", value: 0 },
            cd: { key: "50000187", type: "text", value: 0 },
            desc: { key: "50000098", type: "text", value: "描述" }
          },
          level2: {
            icon: { key: "50000099", type: "image", value: defImg },
            name: { key: "50000100", type: "text", value: "升级2" },
            sp: { key: "50000188", type: "text", value: 0 },
            cd: { key: "50000189", type: "text", value: 0 },
            desc: { key: "50000101", type: "text", value: "描述" }
          },
          level3: {
            icon: { key: "50000102", type: "image", value: defImg },
            name: { key: "50000103", type: "text", value: "升级3" },
            sp: { key: "50000190", type: "text", value: 0 },
            cd: { key: "50000191", type: "text", value: 0 },
            desc: { key: "50000104", type: "text", value: "描述" }
          },
          level4: {
            icon: { key: "50000155", type: "image", value: defImg },
            name: { key: "50000156", type: "text", value: "升级4" },
            sp: { key: "50000192", type: "text", value: 0 },
            cd: { key: "50000193", type: "text", value: 0 },
            desc: { key: "50000157", type: "text", value: "描述" }
          },
          level5: {
            icon: { key: "50000158", type: "image", value: defImg },
            name: { key: "50000159", type: "text", value: "升级5" },
            sp: { key: "50000194", type: "text", value: 0 },
            cd: { key: "50000195", type: "text", value: 0 },
            desc: { key: "50000160", type: "text", value: "描述" }
          },
          level6: {
            icon: { key: "50000161", type: "image", value: defImg },
            name: { key: "50000162", type: "text", value: "升级6" },
            sp: { key: "50000196", type: "text", value: 0 },
            cd: { key: "50000197", type: "text", value: 0 },
            desc: { key: "50000163", type: "text", value: "描述" }
          },
          level7: {
            icon: { key: "50000164", type: "image", value: defImg },
            name: { key: "50000165", type: "text", value: "升级7" },
            sp: { key: "50000198", type: "text", value: 0 },
            cd: { key: "50000199", type: "text", value: 0 },
            desc: { key: "50000166", type: "text", value: "描述" }
          }
        },
        // 潜力
        potential: {
          item1: {
            icon: { key: "50000343", type: "image", value: defImg },
            desc: { key: "50000344", type: "text", value: "描述" },
            iconDesc: { key: "50000349", type: "image", value: defImg }
          },
          item2: {
            icon: { key: "50000345", type: "image", value: defImg },
            desc: { key: "50000346", type: "text", value: "描述" },
            iconDesc: { key: "50000350", type: "image", value: defImg }
          },
          item3: {
            icon: { key: "50000347", type: "image", value: defImg },
            desc: { key: "50000348", type: "text", value: "描述" },
            iconDesc: { key: "50000351", type: "image", value: defImg }
          }
        }
      },
      introduction: {
        slogn: { key: "50000105", type: "text", value: "简介" },
        nl: {
          label: { key: "50000106", type: "text", value: "年龄" },
          desc: { key: "50000107", type: "text", value: "描述" }
        },
        sg: {
          label: { key: "50000108", type: "text", value: "身高" },
          desc: { key: "50000109", type: "text", value: "描述" }
        },
        sr: {
          label: { key: "50000167", type: "text", value: "生日" },
          desc: { key: "50000168", type: "text", value: "描述" }
        },
        xq: {
          label: { key: "50000110", type: "text", value: "兴趣" },
          desc: { key: "50000111", type: "text", value: "描述" }
        },
        tyddx: {
          label: { key: "50000112", type: "text", value: "讨厌的东西" },
          desc: { key: "50000113", type: "text", value: "描述" }
        },
        sszw: {
          label: { key: "50000114", type: "text", value: "所属/职位" },
          desc: { key: "50000115", type: "text", value: "描述" }
        },
        xhddx: {
          label: { key: "50000116", type: "text", value: "喜欢的东西" },
          desc: { key: "50000117", type: "text", value: "描述" }
        },
        zxddx: {
          label: { key: "50000118", type: "text", value: "珍惜的东西" },
          desc: { key: "50000119", type: "text", value: "描述" }
        },
        cw1: {
          label: { key: "50000120", type: "text", value: "传闻1" },
          desc: { key: "50000121", type: "text", value: "描述" }
        },
        cw2: {
          label: { key: "50000122", type: "text", value: "传闻2" },
          desc: { key: "50000123", type: "text", value: "描述" }
        }
      },
      voices: {
        voices1: {
          source: { key: "50000124", type: "audio", value: "" },
          label: { key: "50000125", type: "text", value: "描述" },
          desc: { key: "50000126", type: "text", value: "描述" }
        },
        voices2: {
          source: { key: "50000127", type: "audio", value: "" },
          label: { key: "50000128", type: "text", value: "描述" },
          desc: { key: "50000129", type: "text", value: "描述" }
        },
        voices3: {
          source: { key: "50000130", type: "audio", value: "" },
          label: { key: "50000131", type: "text", value: "描述" },
          desc: { key: "50000132", type: "text", value: "描述" }
        },
        voices4: {
          source: { key: "50000140", type: "audio", value: "" },
          label: { key: "50000141", type: "text", value: "描述" },
          desc: { key: "50000142", type: "text", value: "描述" }
        },
        voices5: {
          source: { key: "50000143", type: "audio", value: "" },
          label: { key: "50000144", type: "text", value: "描述" },
          desc: { key: "50000145", type: "text", value: "描述" }
        },
        voices6: {
          source: { key: "50000146", type: "audio", value: "" },
          label: { key: "50000147", type: "text", value: "描述" },
          desc: { key: "50000148", type: "text", value: "描述" }
        },
        voices7: {
          source: { key: "50000149", type: "audio", value: "" },
          label: { key: "50000150", type: "text", value: "描述" },
          desc: { key: "50000151", type: "text", value: "描述" }
        },
        voices8: {
          source: { key: "50000152", type: "audio", value: "" },
          label: { key: "50000153", type: "text", value: "描述" },
          desc: { key: "50000154", type: "text", value: "描述" }
        },
        voices9: {
          source: { key: "50000169", type: "audio", value: "" },
          label: { key: "50000170", type: "text", value: "描述" },
          desc: { key: "50000171", type: "text", value: "描述" }
        },
        voices10: {
          source: { key: "50000172", type: "audio", value: "" },
          label: { key: "50000173", type: "text", value: "描述" },
          desc: { key: "50000174", type: "text", value: "描述" }
        },
        voices11: {
          source: { key: "50000175", type: "audio", value: "" },
          label: { key: "50000176", type: "text", value: "描述" },
          desc: { key: "50000177", type: "text", value: "描述" }
        },
        voices12: {
          source: { key: "50000178", type: "audio", value: "" },
          label: { key: "50000179", type: "text", value: "描述" },
          desc: { key: "50000180", type: "text", value: "描述" }
        }
      },
      /** 阵容 */
      battle: {
        ql1: {
          ms: { key: "50000200", type: "text", value: "潜力1描述" },
          sp: { key: "50000212", type: "text", value: "潜力1SP数据抓取" },
          tp: { key: "50000213", type: "image", value: "潜力1图片" },
          tb: { key: "50000214", type: "image", value: "潜力1图标" },
          name: { key: "50000215", type: "text", value: "潜力1名称" }
        },
        ql2: {
          ms: { key: "50000204", type: "text", value: "潜力2描述" },
          sp: { key: "50000205", type: "text", value: "潜力2SP数据抓取" },
          tp: { key: "50000206", type: "image", value: "潜力2图片" },
          tb: { key: "50000207", type: "image", value: "潜力2图标" },
          name: { key: "50000216", type: "text", value: "潜力2名称" }
        },
        ql3: {
          ms: { key: "50000208", type: "text", value: "潜力3描述" },
          sp: { key: "50000209", type: "text", value: "潜力3SP数据抓取" },
          tp: { key: "50000210", type: "image", value: "潜力3图片" },
          tb: { key: "50000211", type: "image", value: "潜力3图标" },
          name: { key: "50000217", type: "text", value: "潜力3名称" }
        }
      },
      /** 抽卡 */
      vcard: {
        rate: { key: "50000230", type: "text", value: 0 },
        upRate: { key: "50000231", type: "text", value: 0 },
        /** 宠物 */
        pet: {
          pet1: {
            name: { key: "50000300", type: "text", value: "宠物1" },
            icon: { key: "50000301", type: "image", value: "" },
            skillImage: { key: "50000302", type: "image", value: "" },
            skillDesc: { key: "50000303", type: "text", value: "" },
            skillName: { key: "50000304", type: "text", value: "" },
            repel: { key: "50000325", type: "image", value: "" },
            damageType: { key: "50000326", type: "image", value: "" },
            attackRange: { key: "50000327", type: "text", value: "" }
          },
          pet2: {
            name: { key: "50000305", type: "text", value: "宠物2" },
            icon: { key: "50000306", type: "image", value: "" },
            skillImage: { key: "50000307", type: "image", value: "" },
            skillDesc: { key: "50000308", type: "text", value: "" },
            skillName: { key: "50000309", type: "text", value: "" },
            repel: { key: "50000328", type: "image", value: "" },
            damageType: { key: "50000329", type: "image", value: "" },
            attackRange: { key: "50000330", type: "text", value: "" }
          },
          pet3: {
            name: { key: "50000310", type: "text", value: "宠物3" },
            icon: { key: "50000311", type: "image", value: "" },
            skillImage: { key: "50000312", type: "image", value: "" },
            skillDesc: { key: "50000313", type: "text", value: "" },
            skillName: { key: "50000314", type: "text", value: "" },
            repel: { key: "50000331", type: "image", value: "" },
            damageType: { key: "50000332", type: "image", value: "" },
            attackRange: { key: "50000333", type: "text", value: "" }
          },
          pet4: {
            name: { key: "50000315", type: "text", value: "宠物4" },
            icon: { key: "50000316", type: "image", value: "" },
            skillImage: { key: "50000317", type: "image", value: "" },
            skillDesc: { key: "50000318", type: "text", value: "" },
            skillName: { key: "50000319", type: "text", value: "" },
            repel: { key: "50000334", type: "image", value: "" },
            damageType: { key: "50000335", type: "image", value: "" },
            attackRange: { key: "50000336", type: "text", value: "" }
          },
          pet5: {
            name: { key: "50000320", type: "text", value: "宠物5" },
            icon: { key: "50000321", type: "image", value: "" },
            skillImage: { key: "50000322", type: "image", value: "" },
            skillDesc: { key: "50000323", type: "text", value: "" },
            skillName: { key: "50000324", type: "text", value: "" },
            repel: { key: "50000337", type: "image", value: "" },
            damageType: { key: "50000338", type: "image", value: "" },
            attackRange: { key: "50000339", type: "text", value: "" }
          }
        }
      },
      // 皮肤测评
      evaluation: {
        cover: { key: "50000340", type: "image", value: defImg },
        link: { key: "50000341", type: "text", value: "" },
        title: { key: "50000342", type: "text", value: "皮肤测评标题" }
      }
    },
    style6: {
      name: { key: "60000202", type: "text", value: "名称" },
      tag: { key: "60000201", type: "text", value: "标签" },
      icon: { key: "60000081", type: "image", value: defImg },
      icon1: { key: "60000220", type: "image", value: defImg },
      icon2: { key: "60000221", type: "image", value: defImg },
      icon3: { key: "60000222", type: "image", value: defImg },
      icon4: { key: "60000223", type: "image", value: defImg },
      live2d: {
        source: {
          key: "60000082",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jh_source: {
          key: "60000352",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        jn_source: {
          key: "60000353",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        cg_source: {
          key: "60000354",
          type: "live2d",
          value: {
            json: "",
            atlas: ""
          }
        },
        lh: { key: "60000185", type: "image", value: defImg }
      },
      skill: {
        icon: { key: "60000083", type: "image", value: defImg },
        name: { key: "60000084", type: "text", value: "技能" },
        video: { key: "60000184", type: "video", value: "" },
        desc: { key: "60000085", type: "text", value: "描述" },
        sp: { key: "60000086", type: "text", value: "消耗资源1" },
        cd: { key: "60000087", type: "text", value: "消耗资源2" },
        ability1: {
          name: { key: "60000181", type: "text", value: "绑定能力" },
          desc: { key: "60000088", type: "text", value: "描述" }
        },
        ability2: {
          name: { key: "60000182", type: "text", value: "共同能力" },
          desc: { key: "60000089", type: "text", value: "描述" }
        },
        attr1: {
          icon: { key: "60000090", type: "image", value: defImg },
          name: { key: "60000091", type: "text", value: "属性1" }
        },
        attr2: {
          icon: { key: "60000092", type: "image", value: defImg },
          name: { key: "60000093", type: "text", value: "属性2" }
        },
        attr3: {
          icon: { key: "60000094", type: "image", value: defImg },
          name: { key: "60000095", type: "text", value: "属性3" }
        },
        upgrade: {
          level1: {
            icon: { key: "60000096", type: "image", value: defImg },
            name: { key: "60000097", type: "text", value: "升级1" },
            sp: { key: "60000186", type: "text", value: 0 },
            cd: { key: "60000187", type: "text", value: 0 },
            desc: { key: "60000098", type: "text", value: "描述" }
          },
          level2: {
            icon: { key: "60000099", type: "image", value: defImg },
            name: { key: "60000100", type: "text", value: "升级2" },
            sp: { key: "60000188", type: "text", value: 0 },
            cd: { key: "60000189", type: "text", value: 0 },
            desc: { key: "60000101", type: "text", value: "描述" }
          },
          level3: {
            icon: { key: "60000102", type: "image", value: defImg },
            name: { key: "60000103", type: "text", value: "升级3" },
            sp: { key: "60000190", type: "text", value: 0 },
            cd: { key: "60000191", type: "text", value: 0 },
            desc: { key: "60000104", type: "text", value: "描述" }
          },
          level4: {
            icon: { key: "60000155", type: "image", value: defImg },
            name: { key: "60000156", type: "text", value: "升级4" },
            sp: { key: "60000192", type: "text", value: 0 },
            cd: { key: "60000193", type: "text", value: 0 },
            desc: { key: "60000157", type: "text", value: "描述" }
          },
          level5: {
            icon: { key: "60000158", type: "image", value: defImg },
            name: { key: "60000159", type: "text", value: "升级5" },
            sp: { key: "60000194", type: "text", value: 0 },
            cd: { key: "60000195", type: "text", value: 0 },
            desc: { key: "60000160", type: "text", value: "描述" }
          },
          level6: {
            icon: { key: "60000161", type: "image", value: defImg },
            name: { key: "60000162", type: "text", value: "升级6" },
            sp: { key: "60000196", type: "text", value: 0 },
            cd: { key: "60000197", type: "text", value: 0 },
            desc: { key: "60000163", type: "text", value: "描述" }
          },
          level7: {
            icon: { key: "60000164", type: "image", value: defImg },
            name: { key: "60000165", type: "text", value: "升级7" },
            sp: { key: "60000198", type: "text", value: 0 },
            cd: { key: "60000199", type: "text", value: 0 },
            desc: { key: "60000166", type: "text", value: "描述" }
          }
        },
        // 潜力
        potential: {
          item1: {
            icon: { key: "60000343", type: "image", value: defImg },
            desc: { key: "60000344", type: "text", value: "描述" },
            iconDesc: { key: "60000349", type: "image", value: defImg }
          },
          item2: {
            icon: { key: "60000345", type: "image", value: defImg },
            desc: { key: "60000346", type: "text", value: "描述" },
            iconDesc: { key: "60000350", type: "image", value: defImg }
          },
          item3: {
            icon: { key: "60000347", type: "image", value: defImg },
            desc: { key: "60000348", type: "text", value: "描述" },
            iconDesc: { key: "60000351", type: "image", value: defImg }
          }
        }
      },
      introduction: {
        slogn: { key: "60000105", type: "text", value: "简介" },
        nl: {
          label: { key: "60000106", type: "text", value: "年龄" },
          desc: { key: "60000107", type: "text", value: "描述" }
        },
        sg: {
          label: { key: "60000108", type: "text", value: "身高" },
          desc: { key: "60000109", type: "text", value: "描述" }
        },
        sr: {
          label: { key: "60000167", type: "text", value: "生日" },
          desc: { key: "60000168", type: "text", value: "描述" }
        },
        xq: {
          label: { key: "60000110", type: "text", value: "兴趣" },
          desc: { key: "60000111", type: "text", value: "描述" }
        },
        tyddx: {
          label: { key: "60000112", type: "text", value: "讨厌的东西" },
          desc: { key: "60000113", type: "text", value: "描述" }
        },
        sszw: {
          label: { key: "60000114", type: "text", value: "所属/职位" },
          desc: { key: "60000115", type: "text", value: "描述" }
        },
        xhddx: {
          label: { key: "60000116", type: "text", value: "喜欢的东西" },
          desc: { key: "60000117", type: "text", value: "描述" }
        },
        zxddx: {
          label: { key: "60000118", type: "text", value: "珍惜的东西" },
          desc: { key: "60000119", type: "text", value: "描述" }
        },
        cw1: {
          label: { key: "60000120", type: "text", value: "传闻1" },
          desc: { key: "60000121", type: "text", value: "描述" }
        },
        cw2: {
          label: { key: "60000122", type: "text", value: "传闻2" },
          desc: { key: "60000123", type: "text", value: "描述" }
        }
      },
      voices: {
        voices1: {
          source: { key: "60000124", type: "audio", value: "" },
          label: { key: "60000125", type: "text", value: "描述" },
          desc: { key: "60000126", type: "text", value: "描述" }
        },
        voices2: {
          source: { key: "60000127", type: "audio", value: "" },
          label: { key: "60000128", type: "text", value: "描述" },
          desc: { key: "60000129", type: "text", value: "描述" }
        },
        voices3: {
          source: { key: "60000130", type: "audio", value: "" },
          label: { key: "60000131", type: "text", value: "描述" },
          desc: { key: "60000132", type: "text", value: "描述" }
        },
        voices4: {
          source: { key: "60000140", type: "audio", value: "" },
          label: { key: "60000141", type: "text", value: "描述" },
          desc: { key: "60000142", type: "text", value: "描述" }
        },
        voices5: {
          source: { key: "60000143", type: "audio", value: "" },
          label: { key: "60000144", type: "text", value: "描述" },
          desc: { key: "60000145", type: "text", value: "描述" }
        },
        voices6: {
          source: { key: "60000146", type: "audio", value: "" },
          label: { key: "60000147", type: "text", value: "描述" },
          desc: { key: "60000148", type: "text", value: "描述" }
        },
        voices7: {
          source: { key: "60000149", type: "audio", value: "" },
          label: { key: "60000150", type: "text", value: "描述" },
          desc: { key: "60000151", type: "text", value: "描述" }
        },
        voices8: {
          source: { key: "60000152", type: "audio", value: "" },
          label: { key: "60000153", type: "text", value: "描述" },
          desc: { key: "60000154", type: "text", value: "描述" }
        },
        voices9: {
          source: { key: "60000169", type: "audio", value: "" },
          label: { key: "60000170", type: "text", value: "描述" },
          desc: { key: "60000171", type: "text", value: "描述" }
        },
        voices10: {
          source: { key: "60000172", type: "audio", value: "" },
          label: { key: "60000173", type: "text", value: "描述" },
          desc: { key: "60000174", type: "text", value: "描述" }
        },
        voices11: {
          source: { key: "60000175", type: "audio", value: "" },
          label: { key: "60000176", type: "text", value: "描述" },
          desc: { key: "60000177", type: "text", value: "描述" }
        },
        voices12: {
          source: { key: "60000178", type: "audio", value: "" },
          label: { key: "60000179", type: "text", value: "描述" },
          desc: { key: "60000180", type: "text", value: "描述" }
        }
      },
      /** 阵容 */
      battle: {
        ql1: {
          ms: { key: "60000200", type: "text", value: "潜力1描述" },
          sp: { key: "60000212", type: "text", value: "潜力1SP数据抓取" },
          tp: { key: "60000213", type: "image", value: "潜力1图片" },
          tb: { key: "60000214", type: "image", value: "潜力1图标" },
          name: { key: "60000215", type: "text", value: "潜力1名称" }
        },
        ql2: {
          ms: { key: "60000204", type: "text", value: "潜力2描述" },
          sp: { key: "60000205", type: "text", value: "潜力2SP数据抓取" },
          tp: { key: "60000206", type: "image", value: "潜力2图片" },
          tb: { key: "60000207", type: "image", value: "潜力2图标" },
          name: { key: "60000216", type: "text", value: "潜力2名称" }
        },
        ql3: {
          ms: { key: "60000208", type: "text", value: "潜力3描述" },
          sp: { key: "60000209", type: "text", value: "潜力3SP数据抓取" },
          tp: { key: "60000210", type: "image", value: "潜力3图片" },
          tb: { key: "60000211", type: "image", value: "潜力3图标" },
          name: { key: "60000217", type: "text", value: "潜力3名称" }
        }
      },
      /** 抽卡 */
      vcard: {
        rate: { key: "60000230", type: "text", value: 0 },
        upRate: { key: "60000231", type: "text", value: 0 },
        /** 宠物 */
        pet: {
          pet1: {
            name: { key: "60000300", type: "text", value: "宠物1" },
            icon: { key: "60000301", type: "image", value: "" },
            skillImage: { key: "60000302", type: "image", value: "" },
            skillDesc: { key: "60000303", type: "text", value: "" },
            skillName: { key: "60000304", type: "text", value: "" },
            repel: { key: "60000325", type: "image", value: "" },
            damageType: { key: "60000326", type: "image", value: "" },
            attackRange: { key: "60000327", type: "text", value: "" }
          },
          pet2: {
            name: { key: "60000305", type: "text", value: "宠物2" },
            icon: { key: "60000306", type: "image", value: "" },
            skillImage: { key: "60000307", type: "image", value: "" },
            skillDesc: { key: "60000308", type: "text", value: "" },
            skillName: { key: "60000309", type: "text", value: "" },
            repel: { key: "60000328", type: "image", value: "" },
            damageType: { key: "60000329", type: "image", value: "" },
            attackRange: { key: "60000330", type: "text", value: "" }
          },
          pet3: {
            name: { key: "60000310", type: "text", value: "宠物3" },
            icon: { key: "60000311", type: "image", value: "" },
            skillImage: { key: "60000312", type: "image", value: "" },
            skillDesc: { key: "60000313", type: "text", value: "" },
            skillName: { key: "60000314", type: "text", value: "" },
            repel: { key: "60000331", type: "image", value: "" },
            damageType: { key: "60000332", type: "image", value: "" },
            attackRange: { key: "60000333", type: "text", value: "" }
          },
          pet4: {
            name: { key: "60000315", type: "text", value: "宠物4" },
            icon: { key: "60000316", type: "image", value: "" },
            skillImage: { key: "60000317", type: "image", value: "" },
            skillDesc: { key: "60000318", type: "text", value: "" },
            skillName: { key: "60000319", type: "text", value: "" },
            repel: { key: "60000334", type: "image", value: "" },
            damageType: { key: "60000335", type: "image", value: "" },
            attackRange: { key: "60000336", type: "text", value: "" }
          },
          pet5: {
            name: { key: "60000320", type: "text", value: "宠物5" },
            icon: { key: "60000321", type: "image", value: "" },
            skillImage: { key: "60000322", type: "image", value: "" },
            skillDesc: { key: "60000323", type: "text", value: "" },
            skillName: { key: "60000324", type: "text", value: "" },
            repel: { key: "60000337", type: "image", value: "" },
            damageType: { key: "60000338", type: "image", value: "" },
            attackRange: { key: "60000339", type: "text", value: "" }
          }
        }
      },
      // 皮肤测评
      evaluation: {
        cover: { key: "60000340", type: "image", value: defImg },
        link: { key: "60000341", type: "text", value: "" },
        title: { key: "60000342", type: "text", value: "皮肤测评标题" }
      }
    }
  }
};

/**
 * 70000168
 * 装备绑定入口
 */
export const weapon = {
  /** 专用/通用 */
  type: { key: "70000101", type: "text", value: "专用/制作/魔兽" },
  /** 装备部位 */
  part: { key: "70000102", type: "text", value: "武器/盔甲/头盔/饰品/手套" },
  /** 装备名称 */
  name: { key: "70000103", type: "text", value: "装备名称" },
  role: { key: "70000104", type: "text", value: "所属角色" },
  /** 所属角色星级 */
  roleStar: { key: "70000166", type: "text", value: "五星" },
  /** 装备立绘 */
  lihui: { key: "70000105", type: "image", value: defImg },
  /** 所属角色的头像 */
  avatar: { key: "70000106", type: "image", value: defImg },
  /** 主词条 */
  primary: {
    zynl: { key: "70000107", type: "text", value: "专用能力" },
    jbnl1: { key: "70000108", type: "text", value: "基本能力1" },
    jbnl2: { key: "70000109", type: "text", value: "基本能力2" }
  },
  /** 副词条 */
  secondary: {
    ct1: { key: "70000110", type: "text", value: "词条1" },
    ct2: { key: "70000111", type: "text", value: "词条2" },
    ct3: { key: "70000112", type: "text", value: "词条3" }
  },
  /** 制作装备等级 */
  zzLevel: {
    ur1: {
      /** 主词条 */
      primary: {
        jbnl1: { key: "70000113", type: "text", value: "基本能力1" },
        jbnl2: { key: "70000114", type: "text", value: "基本能力2" }
      },
      /** 副词条 */
      secondary: {
        ct1: { key: "70000115", type: "text", value: "词条1" },
        ct2: { key: "70000116", type: "text", value: "词条2" },
        ct3: { key: "70000117", type: "text", value: "词条3" }
      }
    },
    ur2: {
      /** 主词条 */
      primary: {
        jbnl1: { key: "70000118", type: "text", value: "基本能力1" },
        jbnl2: { key: "70000119", type: "text", value: "基本能力2" }
      },
      /** 副词条 */
      secondary: {
        ct1: { key: "70000120", type: "text", value: "词条1" },
        ct2: { key: "70000121", type: "text", value: "词条2" },
        ct3: { key: "70000122", type: "text", value: "词条3" }
      }
    },
    ur3: {
      /** 主词条 */
      primary: {
        jbnl1: { key: "70000123", type: "text", value: "基本能力1" },
        jbnl2: { key: "70000124", type: "text", value: "基本能力2" }
      },
      /** 副词条 */
      secondary: {
        ct1: { key: "70000125", type: "text", value: "词条1" },
        ct2: { key: "70000126", type: "text", value: "词条2" },
        ct3: { key: "70000127", type: "text", value: "词条3" }
      }
    },
    ur4: {
      /** 主词条 */
      primary: {
        jbnl1: { key: "70000128", type: "text", value: "基本能力1" },
        jbnl2: { key: "70000129", type: "text", value: "基本能力2" }
      },
      /** 副词条 */
      secondary: {
        ct1: { key: "70000130", type: "text", value: "词条1" },
        ct2: { key: "70000131", type: "text", value: "词条2" },
        ct3: { key: "70000132", type: "text", value: "词条3" }
      }
    }
  },
  /** 专用装备等级 */
  zyLevel: {
    sr: {
      /** 主词条 */
      primary: {
        zynl: { key: "70000133", type: "text", value: "专用能力" },
        jbnl1: { key: "70000134", type: "text", value: "基本能力1" },
        jbnl2: { key: "70000135", type: "text", value: "基本能力2" }
      },
      /** 副词条 */
      secondary: {
        ct1: { key: "70000136", type: "text", value: "词条1" },
        ct2: { key: "70000137", type: "text", value: "词条2" },
        ct3: { key: "70000138", type: "text", value: "词条3" }
      }
    },
    ur: {
      /** 主词条 */
      primary: {
        zynl: { key: "70000139", type: "text", value: "专用能力" },
        jbnl1: { key: "70000140", type: "text", value: "基本能力1" },
        jbnl2: { key: "70000141", type: "text", value: "基本能力2" }
      },
      /** 副词条 */
      secondary: {
        ct1: { key: "70000142", type: "text", value: "词条1" },
        ct2: { key: "70000143", type: "text", value: "词条2" },
        ct3: { key: "70000144", type: "text", value: "词条3" }
      }
    }
  },
  /** 魔兽装备 */
  mszb: {
    ur: {
      jbnl1: { key: "70000145", type: "text", value: "" },
      jbnl2: { key: "70000146", type: "text", value: "" }
    },
    sr: {
      jbnl1: { key: "70000167", type: "text", value: "" },
      jbnl2: { key: "70000168", type: "text", value: "" }
    }
  },
  /** 收藏品增益 */
  scpzy: {
    /** 一般 */
    yb: {
      icon: { key: "70000147", type: "image", value: defImg },
      count: { key: "70000148", type: "text", value: "" }
    },
    /** 高级 */
    gj: {
      icon: { key: "70000149", type: "image", value: defImg },
      count: { key: "70000150", type: "text", value: "" }
    },
    /** 顶级 */
    dj: {
      icon: { key: "70000151", type: "image", value: defImg },
      count: { key: "70000152", type: "text", value: "" }
    },
    /** 传说 */
    cs: {
      icon: { key: "70000153", type: "image", value: defImg },
      count: { key: "70000154", type: "text", value: "" }
    }
  },
  /** 专用装备收藏品增益 */
  scpzyZY: {
    sr: { key: "70000163", type: "text", value: "" },
    ur: { key: "70000164", type: "text", value: "" },
    icon: { key: "70000165", type: "image", value: defImg }
  },
  /** 制作材料 */
  zzcl: {
    cl1: {
      icon: { key: "70000155", type: "image", value: defImg },
      count: { key: "70000156", type: "text", value: "" }
    },
    cl2: {
      icon: { key: "70000157", type: "image", value: defImg },
      count: { key: "70000158", type: "text", value: "" }
    },
    cl3: {
      icon: { key: "70000159", type: "image", value: defImg },
      count: { key: "70000160", type: "text", value: "" }
    },
    cl4: {
      icon: { key: "70000161", type: "image", value: defImg },
      count: { key: "70000162", type: "text", value: "" }
    }
  }
};
